import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const SubKitchen = () => {
  const [users, setUsers] = useState([]);
  const [kitchenId, setKitchenId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedKitchen, setSelectedKitchen] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
      fetchDataList(user.kitchen);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1); // Reset page when filter changes
  }, [searchTerm, selectedKitchen]);

  const fetchDataList = (kitchenId) => {
    axios.get(`https://api-ims.indevconsultancy.in/sub-kichange-get.php?kitchen_id=${kitchenId}`)
      .then((res) => {
        if (res.data.status === "success") {
          const formatted = res.data.data.map((item) => ({
            id: item.subkichen_id,
            kitchenName: item.subKitchen_name,
            status: item.status === "1" ? "Active" : "Inactive",
          }));
          setUsers(formatted);
        } else {
          setUsers([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching sub-kitchens:", err);
        setUsers([]);
      });
  };


  const filteredUsers = users.filter((user) => {
    const matchSearch = user.kitchenName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchDropdown = selectedKitchen ? user.kitchenName === selectedKitchen: true;
    return matchSearch && matchDropdown;
  });

  // Pagination logic
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const paginatedUsers = filteredUsers.slice((currentPage - 1) * itemsPerPage,currentPage * itemsPerPage);

  return (
    <div className="container-fluid px-2">
      <div className="content">
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/mobilehome">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-6 text-end">
            <span className="fs-1">Sub Kitchen List</span>
          </div>
        </div>

        <div className="card">
          <div className="card-header border-info">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setCurrentPage(1);
              }}
            >
              <div className="row g-3 align-items-center">
                {/* Search Box */}
                <div className="col-lg">
                  <input
                    type="text"
                    placeholder="Search Kitchen"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control"
                  />
                </div>

                {/* Dropdown */}
                <div className="col-lg-3">
                  <select
                    className="form-select"
                    value={selectedKitchen}
                    onChange={(e) => setSelectedKitchen(e.target.value)}
                  >
                    <option value="">All Kitchens</option>
                    {users.map((item) => (
                      <option key={item.id} value={item.kitchenName}>
                        {item.kitchenName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Search Button */}
                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Search
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="card-body">
            <div className="table-responsive scrollbar">
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Sub Kitchen</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedUsers.length === 0 ? (
                    <tr>
                      <td colSpan="4">Loading or no data available</td>
                    </tr>
                  ) : (
                    paginatedUsers.map((user, i) => (
                      <tr key={user.id || i}>
                        <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                        <td>{user.kitchenName}</td>
                        <td>
                          <span
                            className={`badge ${user.status === "Active" ? "bg-success" : "bg-danger"
                              }`}
                          >
                            {user.status}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                              // save subkichen_id (or user.id) in localStorage
                              localStorage.setItem("subkichen_id_viwe", user.id);

                              // now navigate
                              navigate("/addkitchen");
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="mt-3 d-flex justify-content-center gap-2">
                <button
                  className="btn btn-secondary btn-sm"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                >
                  Prev
                </button>
                <span className="align-self-center">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-secondary btn-sm"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubKitchen;
